import React, { useState } from 'react';
import "./about.css"

import about from "../../assets/about.jpg"
import aboutstory from "../../assets/aboutstory.png"
import sammy from "../../assets/sammy.png"
import bestcompany from "../../assets/bestcompany.png"
import certified from "../../assets/certified.png"
import organization from "../../assets/organization.png"
import comp from "../../assets/comp.png"
import diamond from "../../assets/diamond.svg"
import lando from "../../assets/lando.png";
import techlash from "../../assets/techlash.png";
import ex from "../../assets/ex.png";
import js from "../../assets/js.png";
import agv from "../../assets/agv.png";
import vasmilogo from "../../assets/sublogo.png";
import arrowpng from "../../assets/arrowpng.svg"
import leftarrow from "../../assets/leftarrow.svg";
import dileeptesto from "../../assets/dileeptesto.jpg";
import swathitesto from "../../assets/swathitesto.jpg";
import saitesto from "../../assets/saibabu.jpg";
import bhagavanbidda from "../../assets/bhagavanbidda.jpg";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import { useRef } from 'react';
import { Link } from 'react-router-dom';  
const About = () => {
  const [expanded, setExpanded] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Dileep',
      designation: 'Frontend Developer',
      image: dileeptesto,
      text: "As a front-end developer at Vasmi Group, I've had the privilege of contributing to innovative projects that have redefined digital experiences in Visakhapatnam. Vasmi Group's commitment to excellence and fostering a collaborative work environment has been instrumental in my professional growth. I'm proud to be a part of a company that prioritizes employee satisfaction and delivering exceptional results to clients."
    },
    {
      name: 'Bhagavan',
      designation: 'Senior Developer',
      image: bhagavanbidda,
      text: "In my role as a senior developer at Vasmi Group, I've witnessed firsthand the company's unwavering dedication to driving growth and innovation in Visakhapatnam's digital landscape. Vasmi Group's emphasis on fostering a culture of learning and collaboration has enabled me to expand my skill set and take on new challenges with confidence. I'm grateful to be a part of a team that values excellence and empowers its employees to thrive."
    },
    {
      name: 'Venkat Sai',
      designation: 'Ui& Ux Designer',
      image: saitesto,
      text: "As a UI/UX developer at Vasmi Group, I've had the opportunity to work on projects that push the boundaries of creativity and innovation. Vasmi Group's supportive work environment and emphasis on professional development have enabled me to grow both personally and technically. I'm proud to be a part of a company that prioritises employee well-being and encourages us to strive for excellence in everything we do."
    },
  ];
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  const handleLeftClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1));
  };

  const handleRightClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1));
  };
  return (

<>

     <Helmet>
          <title>Vasmi Group | Top Digital Marketing Agency in Vizag</title>
        </Helmet>

        <div className='about-main-container'></div>
    
    <div className='about'>
    <div className='about-main'>
    <img src={about} alt='about'/>
    <p className='about-head-main'>About Us</p>
    </div>
    <div className='sde-sec-one about-sec-img'>
        <div className='sde-sec-one-left about-secure'>
            <p className='sde-sec-left-heading about-sec-head'>
            <strong>

            Our Story
            </strong>

            </p>
            <p className='sde-sec-one-para about-secc'>
            Our story at Vasmi Group began with a vision to revolutionize talent acquisition, IT solutions, 
            and marketing strategies in Visakhapatnam. Founded by Mr. Sai Krishna Voonna, our journey is fueled
             by a commitment to excellence and innovation. With a focus on digital marketing in Vizag and beyond, 
             we strive to stand out as the top choice for businesses seeking advertising agencies in Visakhapatnam. 
             Through strategic SEO services, we elevate brand visibility, while our mobile app development in Vizag 
             ensures cutting-edge technology solutions. As a leading recruitment agency in Visakhapatnam, 
             we connect top-tier talent with thriving businesses. At Vasmi Group, our motto is to be your trusted 
             partner on the journey to excellence.
            </p>

            
        </div>
        <img src={aboutstory} alt='sde' className='krishh'/>
      </div>
      <div className='about-sec-one'>
      <div className='about-sec-one-para'> 
      <p className='about-sec-one-story'>
      Our Vision
      </p>
      <p className='about-sec-one-sub-para'>
      At Vasmi Group, our vision is to be the architects of digital success, seamlessly blending innovation,  strategy, and expertise. We aspire to redefine business excellence by offering comprehensive digital  marketing, website development, and recruitment services. Our mission is to empower brands with a  dynamic online presence, crafted through cutting-edge websites and fuelled by strategic digital  marketing campaigns. We envision not just fulfilling but exceeding our client's expectations, creating  an ecosystem where businesses thrive, websites resonate, and teams flourish.
            </p>
      </div>
      <div className='about-sec-one-para'> 
      <p className='about-sec-one-story'>
        Our Mission
      </p>
      <p className='about-sec-one-sub-para'>
      At Vasmi Group, our mission is to catalyze your digital ascendancy through an integrated approach of  unparalleled digital marketing, bespoke website development, and strategic recruitment services.  We are committed to fostering your brand's online resonance, leveraging cutting-edge technologies  and innovative strategies. Our dedicated team strives to empower businesses with impactful digital  solutions, ensuring your digital footprint transcends expectations. Through adept website  development and astute recruitment, we aim to build not just brands, but sustainable ecosystems of  success.

            </p>
      </div>
      </div>
      <div className='about-sec-two'>
      <p className='about-sec-two-head'>
        Our Values
      </p>

      <div className='about-sec-sub-two'>
        <div className='about-sec-sub-two-one'>


        <p className='about-sec-two-head-two'>
        Innovation
        </p>

        <p className='about-sec-two-head-three'>
        Igniting tech excellence, crafting avant-garde marketing, and pioneering recruitment  solutions that redefine industry standards, ensuring clients stay ahead in the digital and IT landscape.

        </p>

        </div>
        <div className='about-sec-sub-two-one'>


        <p className='about-sec-two-head-two'>
        Collaboration
                </p>

        <p className='about-sec-two-head-three'>
        Fostering synergy between tech brilliance and strategic marketing, facilitating  seamless collaboration in our recruitment endeavors, building comprehensive solutions that drive  success for clients.

        </p>

        </div>
        <div className='about-sec-sub-two-one'>


        <p className='about-sec-two-head-two'>
        Integrity
                </p>

        <p className='about-sec-two-head-three'>
        Upholding unwavering ethical standards, ensuring transparent communication, and  delivering trustworthy marketing, IT services, and recruitment processes that cultivate  enduring relationships and client satisfaction.

        </p>

        </div>
        <div className='about-sec-sub-two-one'>


        <p className='about-sec-two-head-two'>
        Adaptability
                </p>

        <p className='about-sec-two-head-three'>
        Embracing the ever-evolving digital and IT landscape, we tailor agile strategies, ensuring  our clients remain adaptable and competitive in dynamic markets, driving sustainable success.

        </p>

        </div>
      </div>
     </div>      
    </div>
    </>
  );
}

export default About;
